export default class FileData {
  id?: string; // Optional ID for the file, if needed
  title?: string; // Optional title for the file
  fileUrl?: string; // Optional URL for the file, if needed
  removed?: boolean; // Optional flag to indicate if the file has been removed
  blobFile?: File; // Optional Blob file for the file data
  in_description?: boolean; // Optional flag to indicate if the file is in description

  constructor(fileData) {
    this.id = fileData.id;
    this.title = fileData.title;
    this.fileUrl = fileData.file;
  }

  setBlobFile(blobFile: File) {
    this.blobFile = blobFile;
  }
  setRemoved(removed: boolean) {
    this.removed = removed;
  }

  getFileMime() {
    return this.blobFile?.type || mimeFromUrl(this.fileUrl);
  }

  getFileKind(): FILE_KIND {
    const mime = this.getFileMime();

    return kindFromMime(mime);
  }

  static fromFile(file: File): FileData {
    const fileData = new FileData({});

    fileData.setBlobFile(file);
    fileData.title = file.name;

    return fileData;
  }
}

function mimeFromUrl(url?: string): string | undefined {
  if (!url) return;
  const ext = url.split('?')[0].split('#')[0].split('.').pop()?.toLowerCase();

  switch (ext) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'webp':
    case 'bmp':
      return `image/${ext === 'jpg' ? 'jpeg' : ext}`;
    case 'svg':
      return 'image/svg+xml';
    case 'mp4':
    case 'webm':
    case 'ogg':
      return `video/${ext}`;
    case 'mp3':
    case 'wav':
    case 'aac':
    case 'flac':
      return ext === 'aac' ? 'audio/aac' : `audio/${ext}`;
    case 'pdf':
      return 'application/pdf';
    case 'txt':
    case 'log':
    case 'md':
      return 'text/plain';
    case 'json':
      return 'application/json';
    default:
      return;
  }
}

export enum FILE_KIND {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  PDF = 'pdf',
  TEXT = 'text',
  OTHER = 'other',
}

function kindFromMime(mime?: string): FILE_KIND {
  if (!mime) return FILE_KIND.OTHER;
  if (mime.startsWith('image/')) return FILE_KIND.IMAGE;
  if (mime.startsWith('video/')) return FILE_KIND.VIDEO;
  if (mime.startsWith('audio/')) return FILE_KIND.AUDIO;
  if (mime === 'application/pdf') return FILE_KIND.PDF;
  if (mime.startsWith('text/') || mime === 'application/json') return FILE_KIND.TEXT;

  return FILE_KIND.OTHER;
}
